// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AddDeductionInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/add_deduction
 *
 * Validates input for adding a user-level deduction to a payroll period.
 */
import { registerContract } from './validate'

export interface Payroll_AddDeductionInput {
period_id: number
user_id: string
amount: number
franchise_id: number
description?: string
despesa_id?: number
}

registerContract('Payroll_AddDeductionInput', {
  period_id:    { type: 'number',  required: true },
  user_id:      { type: 'string',  required: true },
  amount:       { type: 'number',  required: true },
  franchise_id: { type: 'number',  required: true },
  description:  { type: 'string',  required: false },
  despesa_id:   { type: 'number',  required: false },
})
